<template>
  <div class="bg-primary">
    <!-- Header -->
    <div class="header bg-gradient-blue py-7 py-lg-6 pt-lg-5">
      <b-container>
        <div class="header-body text-center mb-5">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">
                Reset your password
              </h1>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-primary" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--7 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <base-alert
                v-if="errorMessage"
                :dismissible="false"
                type="default"
                >Error: {{ errorMessage }}</base-alert
              >

              <base-alert v-if="success" :dismissible="false" type="success">
                <p class="text-lg">
                  Your password has been reset successfully. You may now log in
                  using your new password.
                </p>
                <b-btn to="/login" block variant="default" style="color: #fff"
                  >Log in</b-btn
                >
              </base-alert>

              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form
                  role="form"
                  v-if="!success"
                  @submit.prevent="handleSubmit(resetPassword)"
                >
                  <base-input
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-lock-circle-open"
                    placeholder="Password"
                    type="password"
                    name="Password"
                    :rules="{ required: true, min: 8 }"
                    :debounce="500"
                    v-model="model.password"
                  >
                  </base-input>
                  <div class="text-muted">
                    <small v-if="passwordStrength"
                      >Password strength:
                      <span
                        :class="passwordStrength.class"
                        class="font-weight-700"
                        >{{ passwordStrength.value }}</span
                      ></small
                    >
                    <small v-else>&nbsp;</small>
                  </div>

                  <div class="text-center">
                    <base-button
                      native-type="submit"
                      type="primary"
                      class="mt-4 btn-block"
                    >
                      <span v-if="!working">
                        Reset password
                        <i class="fa fa-arrow-right ml-2"></i>
                      </span>
                      <span v-else>
                        Please wait&hellip;
                        <i class="fa fa-spin fa-spinner ml-2"></i>
                      </span>
                    </base-button>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { BaseAlert } from "@/components";
import { get } from "dot-prop";
import passwordStrength from "check-password-strength";

export default {
  components: {
    BaseAlert
  },
  props: {
    ticketId: {
      type: String,
      description: "Ticket ID",
      required: true
    },
    token: {
      type: String,
      description: "Verification Token",
      required: true
    }
  },
  data() {
    return {
      working: false,
      model: {
        password: ""
      },
      success: false,
      errorMessage: null
    };
  },
  computed: {
    passwordStrength() {
      if (this.model.password.length < 1) {
        return null;
      } else {
        const strength = passwordStrength(this.model.password);

        let result = strength;
        if (strength.id === 0) {
          result.class = "text-danger";
        } else if (strength.id === 1) {
          result.class = "text-warning";
        } else if (strength.id === 2) {
          result.class = "text-success";
        }

        return result;
      }
    }
  },
  methods: {
    resetPassword() {
      this.working = true;

      const requestBody = {
        verificationToken: this.token,
        newPassword: this.model.password
      };

      this.axios
        .put(
          `/v1/password-reset-tickets/${this.ticketId}/completion`,
          requestBody
        )
        .then(response => {
          this.working = false;
          this.success = true;
        })
        .catch(error => {
          this.working = false;
          this.errorMessage = `Error verifying email: ${error.response.statusText}`;
          if (get(error, "response.data.message")) {
            this.errorMessage = error.response.data.message;
          }
        });
    }
  }
};
</script>
